import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/views/login'
// import HelloWorld from '../components/HelloWorld'

/* Layout */
import Layout from '@/layout'

Vue.use(Router)

// 所有权限通用路由表
// 如首页和登录页和一些不用权限的公用页面
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    // component: Login,
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/map',
    component: () => import('@/views/map/map'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/map',
    children: [
      {
        path: 'map',
        component: () => import('@/views/map/map'),
        name: 'Map',
        meta: { title: 'Map View', icon: 'map', affix: true }
      }
    ]
  }
  /* {
    path: '/main',
    component: () => import('@/views/main/index')
  } */
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export var asyncRoutes = []
let isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
if (isMobile) { // 移动端
  asyncRoutes = [
    {
      path: '/childsystem1',
      component: Layout,
      children: [
        {
          path: 'summary',
          component: () => import('@/views/childsystem1/summary/index'),
          name: 'Summary',
          meta: { title: 'Summary', icon: 'dashboard', affix: true }
        }
      ]
    },
    {
      path: '/childsystem1/report',
      component: Layout,
      children: [
        {
          path: 'report',
          component: () => import('@/views/childsystem1/report/index'),
          name: 'Report',
          meta: { title: 'Report', icon: 'report' }
        }
      ]
    },
    {
      path: '/childsystem1/inspection',
      component: Layout,
      children: [
        {
          path: 'inspection',
          component: () => import('@/views/childsystem1/inspection/MobileInspection'),
          name: 'inspection',
          meta: { title: 'Inspection', icon: 'chakan' }
        }
      ]
    },
    {
      path: '/childsystem1/management',
      component: Layout,
      children: [
        {
          path: 'management',
          component: () => import('@/views/childsystem1/management/index'),
          name: 'management',
          meta: { title: 'Management', icon: 'user' }
        }
      ]
    }
  ]
} else { // PC端
  asyncRoutes = [
    {
      path: '/childsystem1',
      component: Layout,
      children: [
        {
          path: 'summary',
          component: () => import('@/views/childsystem1/summary/index'),
          name: 'Summary',
          meta: { title: 'Summary', icon: 'dashboard', affix: true }
        }
        // {
        //   path: 'home',
        //   component: () => import('@/views/childsystem1/home/Index'),
        //   name: 'Summary',
        //   meta: { title: 'Summary', icon: 'dashboard', affix: true }
        // }
      ]
    },
    // { // 显示
    //   path: '/childsystem1/ShowPicture',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'Picture',
    //       component: () => import('@/views/childsystem1/ShowPicture/Index'),
    //       name: 'Picture',
    //       meta: { title: 'Picture', icon: 'dashboard' }
    //     }
    //   ]
    // },
    /* path: '/permission',
      // component: Layout,
      redirect: '/permission/page',
      alwaysShow: true, // will always show the root menu
      name: 'Permission',
      meta: {
        title: 'Permission',
        icon: 'lock',
        roles: ['admin', 'editor'] // you can set roles in root nav
      },
      children: [
        {
          path: 'page',
          component: () => import('@/views/permission/page'),
          name: 'PagePermission',
          meta: {
            title: 'Page Permission',
            roles: ['admin'] // or you can only set roles in sub nav
          }
        },
        {
          path: 'directive',
          component: () => import('@/views/permission/directive'),
          name: 'DirectivePermission',
          meta: {
            title: 'Directive Permission'
            // if do not set roles, means: this page does not require permission
          }
        },
        {
          path: 'role',
          component: () => import('@/views/permission/role'),
          name: 'RolePermission',
          meta: {
            title: 'Role Permission',
            roles: ['admin']
          }
        },
        // 404 page must be placed at the end !!!
        { path: '*', redirect: '/404', hidden: true }
      ]
    }, */
    // {
    //   path: '/childsystem1/data',
    //   redirect: '/childsystem1/data/stress',
    //   meta: { title: 'Sensor Data', icon: 'tubiao' },
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'sensor',
    //       component: () => import('@/views/childsystem1/sensor/index'),
    //       name: 'Sensor',
    //       meta: { title: 'Sensor Data', icon: 'sensor' },
    //       hidden: true
    //     },
    //     {
    //       path: 'strain',
    //       component: () => import('@/views/childsystem1/strain/index'),
    //       name: 'Strain',
    //       meta: { title: 'Strain Gague', icon: 'sensor' }
    //       // hidden: true
    //     },
    //     {
    //       path: 'stress',
    //       component: () => import('@/views/childsystem1/stress/index'),
    //       name: 'Stress',
    //       meta: { title: 'Stress', icon: 'yingbian' }
    //       // hidden: true
    //     },
    //     {
    //       path: 'deformation',
    //       component: () => import('@/views/childsystem1/deformation/index'),
    //       name: 'Deformation',
    //       meta: { title: 'Deformation', icon: 'bianxing' }
    //       // hidden: true
    //     },
    //     {
    //       path: 'load',
    //       component: () => import('@/views/childsystem1/load/index'),
    //       name: 'Load',
    //       meta: { title: 'Wheel Load', icon: 'load' }
    //       // hidden: true
    //     }
    //   ]
    // },
    // {
    //   path: '/childsystem1/vibration',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'vibration',
    //       component: () => import('@/views/childsystem1/vibration/index'),
    //       name: 'Vibration',
    //       meta: { title: 'Vibration', icon: 'zhendong' }
    //     }
    //   ]
    // },
    {
      path: '/childsystem1/report',
      component: Layout,
      children: [
        {
          path: 'report',
          component: () => import('@/views/childsystem1/report/index'),
          name: 'Report',
          meta: { title: 'Report', icon: 'report' }
        }
      ]
    },
    {
      path: '/childsystem1/inspection',
      component: Layout,
      children: [
        {
          path: 'inspection',
          component: () => import('@/views/childsystem1/inspection/index'),
          name: 'inspection',
          meta: { title: 'Inspection', icon: 'chakan' }
        }
      ]
    },
    {
      path: '/childsystem1/management',
      component: Layout,
      children: [
        {
          path: 'management',
          component: () => import('@/views/childsystem1/management/index'),
          name: 'management',
          meta: { title: 'Management', icon: 'user' }
        }
      ]
    },
    {
      path: '/childsystem1/warningReceiver',
      component: Layout,
      children: [
        {
          path: 'warningReceiver',
          component: () => import('@/views/childsystem1/warningReceiver/Index'),
          name: 'warningReceiver',
          meta: { title: 'Warning Receiver', icon: 'user' }
        }
      ]
    },
    { // 模型桥
      path: '/childsystem1/modelBridge',
      component: Layout,
      children: [
        {
          path: 'modelBridge',
          component: () => import('@/views/childsystem1/modelBridge/Index'),
          name: 'modelBridge',
          meta: { title: 'Model Bridge', icon: 'model' }
        }
      ]
    }
    // {
    //   path: '/childsystem1/warninglist',
    //   component: Layout,
    //   children: [
    //     {
    //       path: 'warninglist',
    //       component: () => import('@/views/childsystem1/warninglist/index'),
    //       name: 'Warninglist',
    //       hidden: true
    //     }
    //   ]
    // }
    /* {
      path: '/loadrate',
      component: Layout,
      children: [
        {
          path: 'loadrate',
          component: () => import('@/views/loadrate/index'),
          name: 'loadrate',
          meta: { title: '承载力评级', icon: 'pingjixuanze' }
        }
      ]
    }, */
  ]
}
// 实例化vue的时候只挂载constantRouter
const creatRouter = () => new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = creatRouter()

export function resetRouter () {
  const newRouter = creatRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js